import { render, staticRenderFns } from "./VUSearch.vue?vue&type=template&id=e3aca258&"
import script from "./VUSearch.vue?vue&type=script&lang=ts&"
export * from "./VUSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports